export class ArrayHelper {
    onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
    }
}